module.exports = __webpack_public_path__ + "img/parallax3-1200p.08336c16.jpg";